import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MessageCircle, ExternalLink } from "lucide-react";
import { contactInfo, journalUrl } from "../data/projects";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="mt-32 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="glass rounded-[32px] p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <h3 className="font-fraunces text-3xl md:text-4xl font-light text-slate-900 dark:text-slate-100 leading-tight">
                Photography <br /> by STXP
              </h3>
              <p className="mt-4 font-manrope text-sm text-slate-500 dark:text-slate-400 max-w-sm leading-relaxed">
                Visual storytelling through portrait, documentary, architecture,
                product and conceptual photography. Based in the Netherlands.
              </p>
            </div>

            <div className="md:col-span-3">
              <div className="font-manrope text-[10px] tracking-[0.3em] uppercase text-[#A8D2FA] mb-4">
                Contact
              </div>
              <ul className="space-y-3 font-manrope text-sm text-slate-700 dark:text-slate-200">
                <li className="flex items-center gap-2">
                  <Mail size={14} className="text-slate-400 dark:text-slate-500" />
                  <a
                    href={`mailto:${contactInfo.email}`}
                    data-testid="footer-email"
                    className="hover:text-slate-900 dark:text-slate-100 transition"
                  >
                    {contactInfo.email}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <Instagram size={14} className="text-slate-400 dark:text-slate-500" />
                  <a
                    href={contactInfo.instagramUrl}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-instagram"
                    className="hover:text-slate-900 dark:text-slate-100 transition"
                  >
                    {contactInfo.instagram}
                  </a>
                </li>
                <li className="flex items-center gap-2">
                  <MessageCircle size={14} className="text-slate-400 dark:text-slate-500" />
                  <a
                    href={contactInfo.whatsappUrl}
                    target="_blank"
                    rel="noreferrer"
                    data-testid="footer-whatsapp"
                    className="hover:text-slate-900 dark:text-slate-100 transition"
                  >
                    {contactInfo.whatsapp}
                  </a>
                </li>
              </ul>
            </div>

            <div className="md:col-span-4">
              <div className="font-manrope text-[10px] tracking-[0.3em] uppercase text-[#A8D2FA] mb-4">
                Navigate
              </div>
              <div className="grid grid-cols-2 gap-2 font-manrope text-sm text-slate-700 dark:text-slate-200">
                <Link to="/" className="hover:text-slate-900 dark:text-slate-100 transition">Home</Link>
                <Link to="/portfolio" className="hover:text-slate-900 dark:text-slate-100 transition">Portfolio</Link>
                <Link to="/about" className="hover:text-slate-900 dark:text-slate-100 transition">About</Link>
                <Link to="/contact" className="hover:text-slate-900 dark:text-slate-100 transition">Contact</Link>
                <a
                  href={journalUrl}
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-journal"
                  className="col-span-2 mt-3 inline-flex items-center gap-1.5 rounded-full bg-[#E8F4FF] dark:bg-white/[0.15] border border-[#C6E2FF]/50 dark:border-white/25 dark:text-white px-4 py-2 hover:bg-[#C6E2FF] dark:hover:bg-white/[0.2] transition w-fit"
                >
                  Photography Journal
                  <ExternalLink size={12} />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-white/60 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <p className="font-manrope text-xs text-slate-500 dark:text-slate-400">
              © {new Date().getFullYear()} STXP Photography. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
